// extracted by mini-css-extract-plugin
module.exports = {"module":"header_module__2pVuC","content":"header_content__2sEk3","left":"header_left__ioZQQ","right":"header_right__2XNMv","name":"header_name__2c8b7"};